'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withButtonSize = exports.withTextSize = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 44px;\n      font-size: 36px;\n    '], ['\n      line-height: 44px;\n      font-size: 36px;\n    ']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 32px;\n      font-size: 24px;\n    '], ['\n      line-height: 32px;\n      font-size: 24px;\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 28px;\n      font-size: 20px;\n    '], ['\n      line-height: 28px;\n      font-size: 20px;\n    ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 24px;\n      font-size: 16px;\n    '], ['\n      line-height: 24px;\n      font-size: 16px;\n    ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 20px;\n      font-size: 14px;\n    '], ['\n      line-height: 20px;\n      font-size: 14px;\n    ']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 16px;\n      font-size: 12px;\n    '], ['\n      line-height: 16px;\n      font-size: 12px;\n    ']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 24px;\n      font-size: 16px;\n      padding-left: 32px;\n      padding-right: 32px;\n    '], ['\n      line-height: 24px;\n      font-size: 16px;\n      padding-left: 32px;\n      padding-right: 32px;\n    ']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 24px;\n      font-size: 16px;\n      padding-left: 24px;\n      padding-right: 24px;\n    '], ['\n      line-height: 24px;\n      font-size: 16px;\n      padding-left: 24px;\n      padding-right: 24px;\n    ']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n      line-height: 20px;\n      font-size: 14px;\n      padding-left: 16px;\n      padding-right: 16px;\n    '], ['\n      line-height: 20px;\n      font-size: 14px;\n      padding-left: 16px;\n      padding-right: 16px;\n    ']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n    ', '\n    ', '\n  '], ['\n    ', '\n    ', '\n  ']);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withTextSize = exports.withTextSize = function withTextSize(_ref) {
  var size = _ref.size;

  var sizes = {
    title1: (0, _styledComponents.css)(_templateObject),
    title2: (0, _styledComponents.css)(_templateObject2),
    title3: (0, _styledComponents.css)(_templateObject3),
    body1: (0, _styledComponents.css)(_templateObject4),
    body2: (0, _styledComponents.css)(_templateObject5),
    caption: (0, _styledComponents.css)(_templateObject6)
  };

  return sizes[size];
};

var withButtonSize = exports.withButtonSize = function withButtonSize(_ref2) {
  var size = _ref2.size;

  var sizes = {
    extraLarge: (0, _styledComponents.css)(_templateObject7),
    large: (0, _styledComponents.css)(_templateObject8),
    medium: (0, _styledComponents.css)(_templateObject8),
    small: (0, _styledComponents.css)(_templateObject9)
  };

  return sizes[size];
};

exports.default = function () {
  return (0, _styledComponents.css)(_templateObject10, withTextSize, withButtonSize);
};